import { useMutation } from 'react-query';
import { invoicesService, removeCache } from '../../../services';

export const useCreateInvoiceMutation = () => {
  return useMutation(
    ({ clientYardIds, body }: { clientYardIds: string[]; body: any }) => {
      return invoicesService.create(clientYardIds, body);
    },
    {
      onSettled: () => {
        removeCache(['invoice']);
      },
    },
  );
};

export const useSetInvoicesPendingMutation = () => {
  return useMutation(
    (props: any) => {
      return invoicesService.setPending(props);
    },
    {
      onSettled: () => {
        removeCache(['invoice']);
      },
    },
  );
};

export const useSetInvoicePaidMutation = () => {
  return useMutation(
    (invoiceId: string) => {
      return invoicesService.setPaid(invoiceId);
    },
    {
      onSettled: () => {
        removeCache(['invoice']);
      },
    },
  );
};

export const useDeleteInvoiceMutation = () => {
  return useMutation(
    (invoiceId: string) => {
      return invoicesService.delete(invoiceId);
    },
    {
      onSettled: () => {
        removeCache(['invoice']);
      },
    },
  );
};
